module.exports = __webpack_public_path__ + "img/Logo-linknau-new-white.63baa2d4.svg";